import React, { FC } from 'react';
import { useClsRefereesPositionsQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface SelectCls extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const RefereesPositions: FC<SelectCls> = ({ label, error, control, name, rules }) => {
  const { data } = useClsRefereesPositionsQuery({
    variables: {
      filter: {
        classifier: { name: 'Должность судьи' },
        id_not_in: ['4e4e7ff9-e7ec-41c1-84f6-e3aea9246cb5', '7026b40a-365d-4422-a8f8-12c9da114a43'],
      },
    },
  });
  return (
    <Select
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default RefereesPositions;
